/** @jsx jsx */
import React, { useRef } from "react";
import { jsx } from "theme-ui";
import { Box } from "@shared-components/Box/Box";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Controller } from "swiper";
import "swiper/swiper-bundle.css";
import MediaSliderArrow from "@svg-icons/media-slider-arrow.component.svg";
import MediaSliderEllipse from "@svg-icons/media-slider-ellipse.component.svg";
import { Icon } from "@shared-components/Icon/Icon";
import {
  ellipseStyles,
  mediaSliderContainerStyle,
  rightArrowStyles,
  leftArrowStyles,
  rightArrowSpanStyles,
  leftArrowSpanStyles,
  swiperStyles,
  labelPrevNextButton,
  brewPrevNextButton,
} from "./styles";
import { VideoImageDownload } from "@modules/BottleDownload/VideoImageDownload";
import { generateCbKey } from "../../shared/utils/generate-cbKey";

SwiperCore.use([Controller, Navigation, Pagination]);
export type HybridMediaSliderModuleProps = {
  theme: string;
  slides: {
    format: string;
    src: string;
    title?: string;
    noSound?: boolean;
  }[];
  cbKey: string;
  variant: "brew" | "hybrid" | "mission" | "label" | "process";
  videoTitle?: string;
  HOCSessionId: string;
};

const MissionHybridSlider: React.FC<HybridMediaSliderModuleProps> = (props) => {
  const swiperInstance = useRef<SwiperCore>();

  const initSwiper = (swiper: SwiperCore) => {
    swiperInstance.current = swiper;
  };

  const gotoPrev = (e: HTMLButtonElement) => {
    e.blur();
    if (swiperInstance.current) {
      swiperInstance.current.slidePrev();
    }
  };

  const gotoNext = (e: any) => {
    e.blur();
    if (swiperInstance.current) {
      swiperInstance.current.slideNext();
    }
  };
  const labelVariantStyles = props.variant === "label" && labelPrevNextButton;
  const brewVariantStyles = props.variant === "brew" && brewPrevNextButton;

  return (
    <Box
      key={props.cbKey}
      sx={{
        ...mediaSliderContainerStyle,
        color: props.theme === "light" ? "darkGreen" : "white",
      }}
      variant="mediaSlider.container"
    >
      <Box
        sx={{
          ...swiperStyles,
          ...labelVariantStyles,
          ...brewVariantStyles,
        }}
      >
        <Swiper
          effect="slide"
          watchOverflow
          initialSlide={0}
          spaceBetween={16}
          pagination={{
            clickable: true,
            el: `.swiper-pagination-${props.cbKey}`,
          }}
          navigation={{
            nextEl: `.swiper-button-next-${props.cbKey}`,
            prevEl: `.swiper-button-prev-${props.cbKey}`,
          }}
          loop={props.slides.length > 1}
          onSwiper={(swiper) => initSwiper(swiper)}
        >
          {props.slides.map((slide: any) => {
            if (!slide?.src) return null;

            return (
              <SwiperSlide key={generateCbKey()}>
                <VideoImageDownload
                  theme={props.theme}
                  variant={props.variant}
                  slide={slide}
                  title={slide?.title || ""}
                  description={"description"}
                  cbKey={generateCbKey()}
                  videoTitle={props.videoTitle ?? ""}
                  HOCSessionId={props.HOCSessionId}
                />
              </SwiperSlide>
            );
          })}
          {props.slides && (
            <Box
              sx={{
                "svg circle": {
                  fill: props.theme === "light" ? "darkGreen" : "lightGray",
                },
                "svg path": {
                  fill: props.theme === "light" ? "white" : "darkRed",
                },
              }}
            >
              <button
                className={`swiper-button-prev swiper-button-prev-${props.cbKey}`}
                onClick={(e) => {
                  gotoPrev(e.target as HTMLButtonElement);
                }}
              >
                <Box sx={leftArrowSpanStyles}>
                  <Icon sx={leftArrowStyles} svg={MediaSliderArrow} />
                </Box>
                <Icon sx={ellipseStyles} svg={MediaSliderEllipse} />
              </button>
              <button
                className={`swiper-button-next swiper-button-next-${props.cbKey}`}
                onClick={(e) => gotoNext(e.target)}
              >
                <Box sx={rightArrowSpanStyles}>
                  <Icon sx={rightArrowStyles} svg={MediaSliderArrow} />
                </Box>
                <Icon sx={ellipseStyles} svg={MediaSliderEllipse} />
              </button>
            </Box>
          )}
        </Swiper>
        <div
          className={`swiper-pagination swiper-pagination-${props.cbKey}`}
        ></div>
      </Box>
    </Box>
  );
};

export { MissionHybridSlider };
